module.exports = __webpack_public_path__ + "img/report.997dc72.png";